import { Grid, Group, MultiSelect, Select, Text, Textarea } from '@mantine/core';

import { ProphetRuleForm } from '../../../hooks/useProphetRuleForm';
import { AddButton } from '../../AddButton';
import { RemoveButton } from '../../RemoveButton';

const options = [
  { value: 'date', label: 'Дата' },
  { value: 'image', label: 'Изображение' },
  { value: 'text', label: 'Любой текст' },
];

const countOptions = ['1', '2', '3', '4', '5'];

type TextsProps = {
  form: ProphetRuleForm;
  index: number;
};

const Texts = ({ form, index }: TextsProps) => (
  <div>
    {form.values.requirements[index].texts.map((item, textIndex) => (
      <Grid key={textIndex} align="center">
        <Grid.Col span={10}>
          <Textarea
            label={`Текст уточнения ${textIndex + 1}`}
            {...form.getInputProps(`requirements.${index}.texts.${textIndex}`)}
          />
        </Grid.Col>
        <Grid.Col span={2}>
          <RemoveButton
            onClick={() => form.removeListItem(`requirements.${index}.texts`, textIndex)}
          />
        </Grid.Col>
      </Grid>
    ))}
    <AddButton size={15} onClick={() => form.insertListItem(`requirements.${index}.texts`, '')} />
  </div>
);

type Props = {
  form: ProphetRuleForm;
};

export const Requirements = ({ form }: Props) => {
  return (
    <div>
      <Text ta="center" size="md" mt="md">
        Требования
      </Text>
      {form.values.requirements.map((item, index) => (
        <div key={index}>
          <Group justify="center" gap={0}>
            <Text ta="center" size="xs">
              {index + 1}
            </Text>
            <RemoveButton onClick={() => form.removeListItem('requirements', index)} />
          </Group>
          <Select
            withAsterisk
            label="Тип"
            data={options}
            value={form.values.requirements[index].type}
            onChange={(value) => {
              form.setFieldValue(`requirements.${index}.type`, value);
              form.setFieldValue(`requirements.${index}.count`, []);
              form.setFieldValue(`requirements.${index}.texts`, []);
            }}
            mb="md"
          />
          {item.type !== 'text' && (
            <MultiSelect
              withAsterisk
              label="Подходящее количество"
              data={countOptions}
              {...form.getInputProps(`requirements.${index}.count`)}
              mb="md"
            />
          )}
          <Texts form={form} index={index} />
        </div>
      ))}
      {form.values.requirements.length < 2 && (
        <AddButton
          size={25}
          onClick={() =>
            form.insertListItem('requirements', { type: 'date', count: [], texts: [] })
          }
        />
      )}
    </div>
  );
};
